import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/'
)({
  beforeLoad: ({ params: { subscriptionId, labelSlug, clientType } }) => {
    // Redirect to the overview page for the model if no specific sub-route is specified.
    throw redirect({
      to: AppRoute.FraudAnalysisModelDetailsOverview,
      params: { subscriptionId, labelSlug, clientType },
      replace: true,
    })
  },
})
